import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  companyInfo = {
    name: 'Moonray Pharmaceutical',
    description: 'Moonray Pharmaceuticals Pvt Ltd., A unit of the Sanjivani Healthcare, we are dedicated in delivering best treatments and innovative solutions to meet your health satisfaction. Our mission is to transform lifes of people through the development of effective therapies and improved patient overall health.',
    address: 'P. No. 202,2nd Floor, Malti Apartment,Adiwasi Society, Wadi Naka no. 10,Nagpur - 440023, Maharashtra, India',
    phone: '+91 9721388800',
    email: 'info@moonraypharmaceuticals.com',
    website: 'https://moonraypharmaceuticals.com/',
    socialLinks: [
      { icon: 'fab fa-twitter', link: '/home' },
      { icon: 'fab fa-youtube', link: '/home' },
      { icon: 'fab fa-facebook-f', link: '/home' },
      { icon: 'fab fa-linkedin-in', link: '/home' },
      { icon: 'fab fa-instagram', link: '/home' }
    ]
  };

  usefulLinks = [
    { text: 'Home', link: '/home' },
    { text: 'About Us', link: '/about-us' },
    { text: 'Products', link: '/products' },
    { text: 'Blog', link: '/home' },
    { text: 'Contact Us', link: '/contact' }
  ];

  copyright = {
    year: 2024,
    company: ' Copyright By Moonray Pharmaceuticals',
    companyLink: 'https://anuation.com',
    text: 'Curated By Anuation Labs'
  };

  constructor() { }

  ngOnInit(): void { }
}
